import { render, staticRenderFns } from "./headFeeNewForm.vue?vue&type=template&id=018a6600&scoped=true&"
import script from "./headFeeNewForm.vue?vue&type=script&lang=js&"
export * from "./headFeeNewForm.vue?vue&type=script&lang=js&"
import style0 from "./headFeeNewForm.vue?vue&type=style&index=0&id=018a6600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a6600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VTextField,VTextarea})
